(function ($) {
    var breakSize = 991;
    var lastSize = 0;
    $(function () {
        $('.trade-fair-widget').each(function (accordionIndex) {

            var accordionName = 'trade-fair-accordion' + accordionIndex;
            var $widget = $(this);
            $widget.attr('id', accordionName);

            $widget.find('a[data-toggle="collapse"]').each(function (index) {
                var $toggle = $(this);
                $toggle.attr('href', '#' + accordionName + '-collapse-' + index);
                $toggle.attr('data-parent', '#' + accordionName);
            });

            $widget.find('.panel-collapse').each(function (index) {
                var $panel = $(this);
                $panel.attr('id', accordionName + '-collapse-' + index);
                $panel.on('hide.bs.collapse',
                    function () {
                        return window.innerWidth > breakSize;
                    });
                $panel.on('show.bs.collapse',
                    function () {
                        return window.innerWidth > breakSize;
                    });
            });

        });
    });
    var onResize = function () {
        var $widget = $('.trade-fair-widget');
        if ((lastSize > breakSize || lastSize == 0) && window.innerWidth < breakSize) {
            $('.trade-fair-widget .panel-collapse').each(function () {
                var $this = $(this);
                $this.addClass('in');
                $this.css('height', 'initial');
            });
        } else if ((lastSize < breakSize || lastSize == 0) && window.innerWidth > breakSize) {
            $('.trade-fair-widget .panel-collapse').each(function () {
                $(this).removeClass('in');
            });
        }
        lastSize = window.innerWidth;
    };
    $(window).on('resize', onResize);
    onResize();
})(window.jQuery);